/**
 * The type of (redux) action which sets whether the filmstrip is enabled.
 *
 * {
 *     type: SET_FILMSTRIP_ENABLED,
 *     enabled: boolean
 * }.
 */
export const SET_FILMSTRIP_ENABLED = 'SET_FILMSTRIP_ENABLED';

/**
 * The type of (redux) action which sets whether the filmstrip is visible.
 *
 * {
 *     type: SET_FILMSTRIP_VISIBLE,
 *     visible: boolean
 * }.
 */
export const SET_FILMSTRIP_VISIBLE = 'SET_FILMSTRIP_VISIBLE';

/**
 * The type of (redux) action which sets the dimensions of the tile view grid.
 *
 * {
 *     type: SET_TILE_VIEW_DIMENSIONS,
 *     dimensions: {
 *         gridDimensions: {
 *             columns: number,
 *             height: number,
 *             visibleRows: number,
 *             width: number
 *         },
 *         thumbnailSize: {
 *             height: number,
 *             width: number
 *         },
 *         filmstripWidth: number
 *     }.
 * }.
 */
export const SET_TILE_VIEW_DIMENSIONS = 'SET_TILE_VIEW_DIMENSIONS';

/**
 * The type of (redux) action which sets the dimensions of the thumbnails in horizontal view.
 *
 * {
 *     type: SET_HORIZONTAL_VIEW_DIMENSIONS,
 *     dimensions: Object
 * }.
 */
export const SET_HORIZONTAL_VIEW_DIMENSIONS = 'SET_HORIZONTAL_VIEW_DIMENSIONS';

export const SET_VISIBLE_REMOTE_PARTICIPANTS
  = 'SET_VISIBLE_REMOTE_PARTICIPANTS';

/**
 * Set volume from redux.
 */
export const SET_VOLUME_CHANGE_OF_PARTICIPANTS
  = 'SET_VOLUME_CHANGE_OF_PARTICIPANTS';

/** * The type of (redux) action which sets the tile limit for the tile view.
 *
 * {
 *     type: TILE_VIEW_TILE_LIMIT,
 *     tileViewTileLimit: number
 * }.
 */
export const TILE_VIEW_TILE_LIMIT = 'TILE_VIEW_TILE_LIMIT';


/** * The type of (redux) action which hide the local participant in stage view.
 *
 * {
 *     type: HIDE_LOCAL_PARTICIPANT_IN_STAGE_VIEW,
 *     hideParticipantStageView: boolean
 * }.
 */
export const HIDE_LOCAL_PARTICIPANT_IN_STAGE_VIEW = 'HIDE_LOCAL_PARTICIPANT_IN_STAGE_VIEW';

/**
 * The type of (redux) action which sets the start index for visible participants in tile view carousel.
 *
 * {
 *     type: SET_VISIBLE_PARTICIPANTS_START_INDEX,
 *     startIndex: number
 * }.
 */
export const SET_VISIBLE_PARTICIPANTS_START_INDEX = 'SET_VISIBLE_PARTICIPANTS_START_INDEX';


export const CURRENT_TILE_VIEW_PAGE = 'CURRENT_TILE_VIEW_PAGE';

/**
 * The type of (redux) action which hide the header and footer in filmstrip.
 *
 * {
 *     type: SET_HIDE_HEADER_FOOTER,
 *     hideHeaderFooter: boolean
 * }.
 */
export const SET_HIDE_HEADER_FOOTER = 'SET_HIDE_HEADER_FOOTER';
